export default __webpack_public_path__ + "static/media/buyer-supplier-logo.17d69fe4.svg";